import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ContractService } from '@services/contract/contract.service';
import moment from 'moment/moment';
import hash from 'object-hash';
import { HelperService } from '@services/helper/helper.service';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingComponent } from '../../loading/loading.component';
import { RouterLink } from '@angular/router';

import { MixpanelService } from '@services/mixpanel/mixpanel.service';
import { SidebarService } from '@services/sidebar/sidebar.service';
import { AwTooltipComponent } from '@components/misc/aw-tooltip/aw-tooltip.component';
import { AW } from '@airwallet/types';

type PerformanceContractsResponse = Record<string, (AW.Operator.Contract.PerformingContract | '')[]> & {
    info: { fingerprint: string };
};

@Component({
    selector: 'app-contract-performance-list',
    templateUrl: './contract-performance-list.component.html',
    styleUrls: ['./contract-performance-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, LoadingComponent, TranslateModule, AwTooltipComponent]
})
export class ContractPerformanceListComponent implements OnInit {
    loading = signal(false);
    initLoading = true;
    performanceFingerPrint!: string;

    fromDate!: number;
    toDate!: number;

    contracts: Record<string, (AW.Operator.Contract.PerformingContract | '')[]> | undefined;

    constructor(
        private contractService: ContractService,
        private mixpanelService: MixpanelService,
        private helperService: HelperService,
        protected sidebarService: SidebarService
    ) {}

    async ngOnInit(): Promise<void> {
        this.initLoading = true;
        this.fromDate = moment().subtract(29, 'days').startOf('day').unix() + moment().utcOffset() * 60;
        this.toDate = moment().startOf('day').unix() + moment().utcOffset() * 60;
        await this.getContracts();
        this.initLoading = false;
    }

    async getContracts() {
        this.loading.set(true);
        let params = `fromDate=${this.fromDate}&toDate=${this.toDate}`;
        this.performanceFingerPrint = hash.keys(`${params}${moment()}`);
        params += `&fingerprint=${this.performanceFingerPrint}`;

        this.contracts = await this.contractService.getPerformanceContracts(params).then(res => {
            const response = res as PerformanceContractsResponse;
            if (this.performanceFingerPrint === response.info.fingerprint) {
                for (const group in response) {
                    for (let i = response[group].length; i < 5; i++) {
                        response[group].push('');
                    }
                }
                this.loading.set(false);
                return response;
            }
            return undefined;
        });
    }

    round(num: number): string {
        return num ? `${num < 0 ? '' : '+'}${String(this.helperService.roundToTwoDecimals(num * 100))}%` : '';
    }

    onLinkClick() {
        this.mixpanelService.track('Action: Go To List (Contract) Clicked', { action: 'go to contracts list from home' });
    }
}
